import {
  Activity,
  Bot,
  ChevronLeft,
  CircleDollarSign,
  Compass,
  KeyRound,
  Layers,
  ListChecks,
  Network,
  ScrollText,
  Search,
  Settings,
  ShieldCheck,
  Tag,
  Workflow,
  type LucideIcon
} from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../features/auth/AuthContext";

interface NavigationItem {
  to: string;
  label: string;
  icon: LucideIcon;
}
const navigation: NavigationItem[] = [
  { to: "/", label: "Overview", icon: Activity },
  { to: "/tasks", label: "Tasks", icon: Workflow },
  { to: "/approvals", label: "Approvals", icon: ListChecks },
  { to: "/resources", label: "Resources", icon: Network },
  { to: "/agents", label: "Agents", icon: Bot },
  { to: "/discovery", label: "Discovery", icon: Compass },
  { to: "/channels", label: "Channels", icon: Layers },
  { to: "/pricing", label: "Pricing", icon: Tag },
  { to: "/access", label: "Access", icon: KeyRound },
  { to: "/policy", label: "Policy", icon: ShieldCheck },
  { to: "/usage", label: "Usage", icon: CircleDollarSign },
  { to: "/audit", label: "Audit", icon: ScrollText },
  { to: "/traces", label: "Traces", icon: Search },
  { to: "/settings", label: "Settings", icon: Settings }
];

export function AppShell() {
  const { signOut } = useAuth();
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand-lockup">
          <span className="brand-mark">
            <Network size={19} aria-hidden="true" />
          </span>
          <span>
            <strong>Synapse</strong>
            <small>Control plane</small>
          </span>
        </div>
        <nav aria-label="Primary navigation">
          {navigation.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} end={to === "/"}>
              <Icon size={17} aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <button className="quiet-button disconnect" type="button" onClick={signOut}>
          <ChevronLeft size={16} aria-hidden="true" /> Disconnect
        </button>
      </aside>
      <div className="workspace">
        <header className="utility-bar">
          <span className="live-indicator">
            <i /> Local gateway
          </span>
          <span className="utility-copy">Metadata-only telemetry</span>
        </header>
        <Outlet />
      </div>
    </div>
  );
}
